import Vue from 'vue'
import Vuex from 'vuex'

import journal from '@/store/modules/journal'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		journal,
	},
})
